const boilerplate02 =
`# This is Boilerplate 02

Test one two three four.

*test italics*

`
export {boilerplate02}



// WEBPACK FOOTER //
// ./src/boilerplates/boilerplate02.js